import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {createEffect, Actions, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';

import {map, switchMap, tap, catchError, mergeMap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';

import * as CompareActions from './compare.actions';
import * as ProfileActions from '../../profile/store/profile.actions';
import * as ErrorActions from '../../error/store/error.actions';
import {HttpErrorResponse} from '@angular/common/http';
import {CompareService} from '../compare.service';
import * as fromApp from '../../store/app.reducers';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class CompareEffects {

  getAudits = createEffect(() => this.actions$
    .pipe(
      ofType(CompareActions.GET_COMPARE_DATA),
      map(
        (data: {type: string, payload: {params: any}}) => {
          return data.payload;
        }
      ),
      withLatestFrom(this.store),
      switchMap(
        (data: any) => {
          const params = data[0];
          const state: fromApp.AppState = data[1];
          const ids = state.compare.audits.map((value) => {
            return value.id;
          });
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'compare', box: 'generate', value: false})
          );
          return this.compareService.getCompareData(ids).pipe(
            mergeMap(
              (response: any) => {
                const stat = this.compareService.prepareCompareStat(response);
                return [
                  {
                    type: CompareActions.SET_COMPARE_DATA,
                    payload: response
                  },
                  {
                    type: CompareActions.SET_COMPARE_STAT,
                    payload: stat
                  },
                  {
                     type: ProfileActions.SET_LOADER,
                     payload: {module: 'compare', box: 'generate', value: true}
                  }
                ];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );


  constructor(
    private actions$: Actions,
    private compareService: CompareService,
    private notifierService: ToastrService,
    private router: Router,
    private store: Store<fromApp.AppState>

  ) {}
}
